"use client";
import { jsx } from "react/jsx-runtime";
import configuration from "@intlayer/config/built";
import {
  createContext,
  useContext,
  useMemo,
  useRef
} from "react";
import { v4 as uuid } from "uuid";
const { editor } = configuration;
const CommunicatorContext = createContext({
  postMessage: () => null,
  allowedOrigins: [
    editor?.applicationURL,
    editor?.editorURL,
    editor?.cmsURL
  ],
  senderId: ""
});
const CommunicatorProvider = ({
  children,
  allowedOrigins,
  postMessage
}) => {
  const senderIdRef = useRef(uuid());
  const value = useMemo(
    () => ({ postMessage, allowedOrigins, senderId: senderIdRef.current }),
    [postMessage, allowedOrigins, senderIdRef.current]
  );
  return /* @__PURE__ */ jsx(CommunicatorContext.Provider, { value, children });
};
const useCommunicator = () => useContext(CommunicatorContext);
export {
  CommunicatorProvider,
  useCommunicator
};
//# sourceMappingURL=CommunicatorContext.mjs.map